import type {WebappCurrentUser} from '@dokia/strapi/types';

import * as Sentry from '@sentry/react';

export function clearSentryUser(): void {
  Sentry.setUser(null);
}

export function setSentryUserFromProfile(
  user: null | undefined | WebappCurrentUser,
): void {
  if (!user?.documentId) {
    clearSentryUser();
    return;
  }

  Sentry.setUser({
    id: user.documentId,
  });
}
